<astral-input [control]="control" [helpText]="helpText" [type]="'email'" [inputMode]="'email'"></astral-input>
